import { useKidStore } from '@entities/customer'
import { useCsRoutes } from '@shared/api'

interface UpsellBannerDismissApiReturn {
  dismissUpsellBanner: () => Promise<void>
}

export const useUpsellBannerDismissApi = (): UpsellBannerDismissApiReturn => {
  const { $axios } = useNuxtApp()
  const kidStore = useKidStore()

  const dismissUpsellBanner = async (): Promise<void> => {
    const kidId = kidStore.activeKidId
    if (!kidId) {
      console.warn('missing kidId for upsell-banner/upsell-banner-dismiss.hook.ts')
      return
    }

    const url = useCsRoutes('kids.upsell-banner.dismiss', {
      '[kid_id]': kidId,
    })

    if (!url) {
      console.warn('missing url for upsell-banner/upsell-banner-dismiss.hook.ts')
      return
    }

    try {
      await $axios.post(url)
    } catch (err) {
      console.error('unable to dismiss upsell-banner/upsell-banner-dismiss.hook.ts:', err)
    }
  }

  return { dismissUpsellBanner }
}
